import { Component, OnInit, ViewChild, Input } from '@angular/core';
/* import { StripeScriptTag, StripeToken, StripeCard } from "stripe-angular";
import { StripeSource } from 'stripe-angular/StripeTypes'; */
import { CommonService } from '../common.service';
import { ClientStripeSecret, PaymentMethod } from 'profile-api';
import { Profile } from 'profile-api';
import { GetCreditCardName } from '../utils/credit-card-name-getter'
import { StripeService, StripeCardComponent } from 'ngx-stripe';
import { StripeCardElementOptions, StripeElementsOptions } from '@stripe/stripe-js';
import { Router } from '@angular/router';

@Component({
    selector: 'app-payment-methods',
    templateUrl: './payment-methods.component.html',
    styleUrls: ['./payment-methods.component.css']
})
export class PaymentMethodsComponent implements OnInit {

    @Input('tenderId') tenderId: number;
    @Input('fromTender') fromTender: boolean;
    @Input('fromClusterTender') fromClusterTender: boolean;
    @Input('fromPrepaidPacketBuy') fromPrepaidPacketBuy: boolean;
    @Input('fromQuoteBuy') fromQuoteBuy: boolean;
    @Input('isTenderPacket') isTenderPacket: boolean;

    @ViewChild(StripeCardComponent)
    public card: StripeCardComponent;

    cardOptions: StripeCardElementOptions = {
        style: {
            base: {
                iconColor: '#666EE8',
                color: '#333333',
                fontWeight: '300',
                fontFamily: 'Montserrat, Arial, Helvetica, sans-serif',
                letterSpacing: '2px',
                fontSize: '14px',
                '::placeholder': {
                    color: '#a5a5a5'
                }
            },
            invalid: {
                iconColor: '#d71c03',
                color: '#d71c03'
            },
            complete: {
                color: '#333333',
                fontWeight: '300',
                fontFamily: 'Montserrat, Arial, Helvetica, sans-serif',
                letterSpacing: '2px',
                fontSize: '14px',
                '::placeholder': {
                    color: '#a5a5a5'
                }
            }
        }
    };

    elementsOptions: StripeElementsOptions = {
        locale: 'it'
    };

    constructor(
        private commonService: CommonService,
        private router: Router,
        private stripeService: StripeService
    ) { }

    paymentMethod: PaymentMethod = null;
    extraData = {};
    creditCardName: string = null;
    paymentMethodInitialized: boolean = false;
    error: string = 'no_error';
    cardHolder: string = null;
    loading: boolean = false;
    initialLoading: boolean = true;
    invalidError: string;
    cardHorderError: string = 'no_error';


    ngOnInit() {
        this.commonService.getProfile().then(
            (profile: Profile) => {
                if (profile.firstName || profile.firstName) {
                    this.cardHolder = profile.firstName + ' ' + profile.lastName;
                }
                this.getPaymentMethod();
            }
        ).catch(
            (error) => {
                this.error = 'Impossibile recuperare le informazioni sulla carta di credito.'
            }
        );

    }

    submitCard(): void {
        const name = this.cardHolder;
        this.loading = true;

        this.commonService.getPaymentMethodService().profileClientStripeSecretGet().subscribe(
            (clientStripeSecret: ClientStripeSecret) => {
                this.stripeService.confirmCardSetup(clientStripeSecret.clientSecret,
                    {
                        payment_method:
                        {
                            card: this.card.element,
                            billing_details: {
                                name: name
                            }
                        }
                    }).subscribe((result) => {
                        if (result.error) {
                            // Error creating the token
                            console.log(result.error.message);
                            this.invalidError = result.error.message;
                            this.loading = false;
                        } else {
                            //ok;
                            if (this.fromTender) {
                                if (this.tenderId) {
                                    this.router.navigate(['/acquistapartecipazioneallagara'], { queryParams: { "tenderId": this.tenderId } });
                                } else {
                                    this.router.navigate(['/acquistacreazionegara']);
                                }
                            } else if (this.fromClusterTender) {
                                if (this.tenderId) {
                                    this.router.navigate(['/acquistapartecipazioneallagara'], { queryParams: { "tenderId": this.tenderId } });
                                } else {
                                    this.router.navigate(['/acquistacreazionegaracluster']);
                                }
                            } else if (this.fromQuoteBuy) {
                                this.router.navigate(['/acquistarichiestapreventivo']);
                            } else if (this.fromPrepaidPacketBuy) {
                                this.router.navigate(['/acquistapacchetto'], { queryParams: { "isTenderPacket": this.isTenderPacket } });
                            } else {
                                this.getPaymentMethod();
                                this.loading = false;
                            }

                        }
                    })
            },
            (error) => {
                console.log(error);
                this.invalidError = error;
                this.loading = false;
            }
        );
    }

    getPaymentMethod() {
        this.commonService.getPaymentMethodService().profilePaymentMethodGet().subscribe(
            (paymentMethod: PaymentMethod) => {
                this.paymentMethod = paymentMethod;
                console.log("Loaded payment method: " + JSON.stringify(this.paymentMethod));
                this.creditCardName = GetCreditCardName(paymentMethod.creditCardBrand);
                this.paymentMethodInitialized = true;
                this.initialLoading = false;
            },
            (error) => {
                console.log(error);
                this.paymentMethodInitialized = true;
                this.initialLoading = false;
            }
        )
    }

    onStripeInvalid(error: Error) {
        console.log('Validation Error', error);
        this.error = 'Impossibile recuperare le informazioni sulla carta di credito.'
    }

    /* setStripeToken( token:StripeToken ){
      console.log('Stripe token', token);
      var paymentMethod: PaymentMethod = {};
      paymentMethod.creditCardExpire =  token.card.exp_month + '/' + token.card.exp_year;
      paymentMethod.creditCardLast4 = token.card.last4;
      paymentMethod.creditCardName = token.card.name;
      paymentMethod.creditCardToken = token.id;
      paymentMethod.creditCardBrand = token.card.brand;
      this.commonService.getPaymentMethodService().profilePaymentMethodPost(paymentMethod).subscribe(
        (standardResponse: StandardResponse) => {
          console.log("Success" + JSON.stringify(standardResponse));
          if (this.fromTender) {
            if (this.tenderId) {
              this.router.navigate(['/acquistapartecipazioneallagara'], { queryParams: { "tenderId": this.tenderId } });
              //window.open('acquistapartecipazioneallagara?tenderId=' + this.tenderId,'_self');
            } else {
              this.router.navigate(['/acquistacreazionegara']);
              //window.open('/acquistacreazionegara','_self');
            }
          } else if (this.fromPrepaidPacketBuy) {
            this.router.navigate(['/acquistapacchetto']);
            //window.open('acquistapacchetto','_self');
          } else {
            this.paymentMethod = paymentMethod;
            this.creditCardName = GetCreditCardName(paymentMethod.creditCardBrand);
            this.loading = false;
          }
        },
        (error) => {
          console.log(error);
          this.invalidError = error;
          this.loading = false;
        }
      );
  
    }
   
    setStripeSource( source:StripeSource ){
      console.log('Stripe source', source)    
    }
   
    
    onStripeError( error:Error ){
      this.invalidError = error;
      this.loading = false;
      console.error('Stripe error', error);
    }
  
    async submitCard() {
      this.loading = true;
  
      if (!this.cardHolder) {
        this.loading = false;
        this.cardHorderError = 'Inserire un intestatario.';
        return;
      }
  
      this.extraData = {          
        name: this.cardHolder,
        address_city: "",
        address_line1: "",
        address_line2: "",
        address_state: "",
        address_zip: ""      
      }
      
      let result = await this.stripeCard.createToken(this.extraData);
      
      if (this.invalidError) {
        this.loading = false;
        return
      } 
      
    }*/

    async changeCard() {
        this.paymentMethod = null;
        this.invalidError = null;
    }

}
